
export default (Vue) => {
  Vue.directive('ldacs', {
    inserted: function (el, binding) {
      // todo
      var vaild = function (operId, operCode) {
        operId = String(operId)
        var remove = true
        if (operId) {
          if (operId.indexOf('|') > -1) {// acs="2|3" 拥有2，或者3操作权限
            let operids = operId.split('|')
            remove = false
            for (let i = 0; i < operids.length; i++) {
              if (operCode[operids[i]]) {
                remove = false
                break
              }
            }
          } else if (operId.indexOf('&') > -1) {//acs="2&3" 拥有2和3操作权限
            let operids = operId.split('&')
            remove = false
            for (let i = 0; i < operids.length; i++) {
              if (!operCode[operids[i]]) {
                remove = true
                break
              }
            }
          } else {
            if (operCode.indexOf(operId)>-1) {
              remove = false
            }
          }
        } else {
          remove = false
        }
        return remove
      }

      var acs = binding.value || '1', mode = binding.mode || '1'
      var acsStr = window.localStorage.getItem('userInfo') || '{}', userInfo = JSON.parse(acsStr) || {}
      window.userInfo = userInfo
      if (vaild(acs, [userInfo.vipCorp?userInfo.vipCorp.khlx:1])) {
        el.remove()
      }
    }
  })
  Vue.directive('ldsk', {
    inserted: function (el, binding) {
      // todo
      var vaild = function (operId, operCode) {
        operId = String(operId)
        var remove = true
        if (operId) {
          if (operId.indexOf('|') > -1) {// acs="2|3" 拥有2，或者3操作权限
            let operids = operId.split('|')
            remove = false
            for (let i = 0; i < operids.length; i++) {
              if (operCode[operids[i]]) {
                remove = false
                break
              }
            }
          } else if (operId.indexOf('&') > -1) {//acs="2&3" 拥有2和3操作权限
            let operids = operId.split('&')
            remove = false
            for (let i = 0; i < operids.length; i++) {
              if (!operCode[operids[i]]) {
                remove = true
                break
              }
            }
          } else {
            if (operCode.indexOf(operId)>-1) {
              remove = false
            }
          }
        } else {
          remove = false
        }
        return remove
      }

      var acs = binding.value || '1', mode = binding.mode || '1'
      var acsStr = window.localStorage.getItem('userInfo') || '{}', userInfo = JSON.parse(acsStr) || {}
      window.userInfo = userInfo
      if (acs=='SK') {
        el.remove()
      }
    }
  })
}